module.exports = __webpack_public_path__ + "static/img/ph.557ba2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ph.png
// module id = v2mw
// module chunks = 18